module.exports = "Class Component\n\n- ES6\n\n- Must implement `render`\n\n- Has access to local state and lifecycle hooks\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/notes_3.md
// module id = 1520
// module chunks = 0